import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"
import { ensureArray } from "lib/ensure-array"

export const getAssetsSyncedToSchedule = api(async function assets({
    registers = [],
    systems,
    manufacturers,
    facilities,
    spaces,
    floors,
    types,
    categories,
    descending,
    search,
    skip,
    sort,
    take,
    retrieveByAssetIds = true,
}) {
    const cleanedRegisters = Array.from(
        new Set(ensureArray(registers).filter((id) => typeof id === "string" && id.trim()))
    )

    if (!cleanedRegisters.length) {
        return { totalCount: 0, items: [] }
    }

    return query(
        gql`
            query getAssetsSyncedToSchedule(
                $registers: [String!]!
                $search: String
                $skip: Int
                $take: Int
                $sort: AssetSort
                $descending: Boolean
                $types: [String]
                $manufacturers: [String]
                $systems: [String]
                $categories: [String]
                $floors: [String]
                $facilities: [String]
                $spaces: [String]
                $retrieveByAssetIds: Boolean
            ) {
                assets(
                    skip: $skip
                    take: $take
                    registers: $registers
                    search: $search
                    sort: $sort
                    descending: $descending
                    manufacturers: $manufacturers
                    types: $types
                    systems: $systems
                    categories: $categories
                    spaces: $spaces
                    facilities: $facilities
                    floors: $floors
                    retrieveByAssetIds: $retrieveByAssetIds
                ) {
                    totalCount
                    items {
                        id
                        tag
                        description
                        system
                        name
                        barcode
                        picture
                        manufacturer
                        model
                        aiType
                        aiParent
                        quantity
                        modified
                        type
                        location
                        facility
                        floor
                        space
                        code
                        category
                        serialNumber
                        annualServiceDate
                        warrantyExpiry
                        sfg20Code
                        installationDate
                        expectedLifespan
                        condition
                        assetCriticality
                        carbon
                        energyEfficiency
                    }
                }
            }
        `,
        {
            registers: cleanedRegisters,
            systems,
            manufacturers,
            facilities,
            spaces,
            floors,
            types,
            categories,
            descending,
            search,
            skip,
            take,
            sort,
            retrieveByAssetIds,
        },
        {
            returns: "assets",
            transform: (data) => ({
                ...data,
                items: data.items.map((i) => ({
                    ...i,
                    picture: i.picture ? { documents: i.picture.map((o, i) => ({ href: o, id: i })) } : undefined,
                })),
            }),
        }
    )
})
